import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCookie, setCookie } from "../lib/cookies";

const COOKIE_NAME = "mp_age_confirmed";

/**
 * One-time 21+ confirmation modal. Stored client-side as a non-HttpOnly cookie
 * (not sensitive — this is a compliance flag, not auth). No localStorage.
 */
export default function AgeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!getCookie(COOKIE_NAME)) setOpen(true);
  }, []);

  if (!open) return null;

  const confirm = () => {
    setCookie(COOKIE_NAME, new Date().toISOString());
    setOpen(false);
  };

  const leave = () => {
    window.location.href = "https://www.ncpgambling.org/help-treatment/help-by-state/";
  };

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/85 backdrop-blur-md flex items-center justify-center px-6"
      data-testid="age-gate"
      role="dialog"
      aria-modal="true"
    >
      <div className="max-w-lg w-full bg-zinc-950 border border-[#00D4FF]/40 p-8">
        <div className="overline neon-text mb-3">AGE VERIFICATION</div>
        <h2 className="font-display text-4xl text-white mb-5 leading-tight">
          Are you 21 or older?
        </h2>
        <p className="text-sm text-zinc-400 leading-relaxed mb-6">
          Martingale Playbook covers sports betting strategy. You must be at least 21
          years old (or the legal gambling age in your jurisdiction) to enter. By
          continuing you agree to our{" "}
          <Link to="/terms" className="underline text-zinc-200">Terms</Link> and{" "}
          <Link to="/responsible-gambling" className="underline text-zinc-200">
            Responsible Gambling
          </Link>{" "}
          policy.
        </p>
        <div className="grid grid-cols-2 gap-3">
          <button
            onClick={confirm}
            data-testid="age-gate-confirm"
            className="py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs hover:brightness-110"
          >
            Yes, I'm 21+
          </button>
          <button
            onClick={leave}
            data-testid="age-gate-leave"
            className="py-3 border border-zinc-700 text-zinc-300 font-mono uppercase tracking-widest text-xs hover:border-amber-400 hover:text-amber-400"
          >
            No, exit
          </button>
        </div>
        <p className="mt-6 text-[11px] mono text-zinc-500 text-center tracking-widest uppercase">
          GAMBLE RESPONSIBLY · 1-800-GAMBLER
        </p>
      </div>
    </div>
  );
}
